import { render, staticRenderFns } from "./GroupCalendar.vue?vue&type=template&id=6fa6c84d&"
import script from "./GroupCalendar.vue?vue&type=script&lang=js&"
export * from "./GroupCalendar.vue?vue&type=script&lang=js&"
import style0 from "./GroupCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports